module.exports = __webpack_public_path__ + "media/images/homepage_images/home_1-9b054cf621659123e14871b6fb046fc6.svg";